module.exports = __webpack_public_path__ + "img/مستطیل.8fff683e.png";